import { Card } from '../../../shared/components/ui/card';
import { Eye, Users, MessageCircle, Star } from 'lucide-react';

type DashboardStatsProps = {
  stats: {
    profileViews: number;
    newLeads: number;
    unreadMessages: number;
    rating: number;
    reviewCount: number;
  };
  isOnboardingComplete?: boolean;
};

type StatCardProps = {
  title: string;
  value: string;
  description: string;
  icon: React.ElementType;
};

function StatCard({ title, value, description, icon: Icon }: StatCardProps) {
  return (
    <Card className="p-6">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm text-text-secondary">{title}</h3>
        <Icon className="w-5 h-5 text-sage" aria-hidden="true" />
      </div>
      <p className="text-3xl text-text-primary mb-1">{value}</p>
      <p className="text-sm text-text-tertiary">{description}</p>
    </Card>
  );
}

export function DashboardStats({
  stats,
}: DashboardStatsProps) {
  const formatRating = (rating: number): string => {
    if (rating === 0) return '--';
    return rating.toFixed(1);
  };

  const formatReviewCount = (): string => {
    return 'Coming soon';
  };

  const getProfileViewsDescription = (): string => {
    return 'Last 30 days';
  };

  return (
    <div className="grid md:grid-cols-4 gap-6">
      <StatCard
        title="Profile Views"
        value={stats.profileViews.toString()}
        description={getProfileViewsDescription()}
        icon={Eye}
      />

      <StatCard
        title="New Consultations"
        value={stats.newLeads.toString()}
        description="This week"
        icon={Users}
      />

      <StatCard
        title="Messages"
        value={stats.unreadMessages.toString()}
        description="Unread"
        icon={MessageCircle}
      />

      <StatCard
        title="Rating"
        value={formatRating(stats.rating)}
        description={formatReviewCount()}
        icon={Star}
      />
    </div>
  );
}

